<template>
    <div>
        <div class="date-input">
            <b-input
                type="text"
                maxlength="4"
                v-model="internalYear"
                @input="moveToNext('year', $event)"
                ref="year"
                :placeholder="$t('form.YYYY')"
            />
            <span>-</span>
            <b-input
                type="text"
                maxlength="2"
                v-model="internalMonth"
                @input="moveToNext('month', $event)"
                @keydown.backspace="moveToPrevious('month')"
                ref="month"
                :placeholder="$t('form.MM')"
            />
            <span>-</span>
            <b-input
                type="text"
                maxlength="2"
                v-model="internalDay"
                @input="moveToNext('day', $event)"
                @keydown.backspace="moveToPrevious('day')"
                ref="day"
                :placeholder="$t('form.DD')"
            />
        </div>
        <div class="validation-area">
            <div :key="getCompleteDate()" v-if="showValidationFeedback">
                {{ $t('form.invalidDate') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            internalFull: '',
            internalYear: '',
            internalMonth: '',
            internalDay: '',
            valid: false,
            filled: false,
        };
    },
    mounted() {
        const valid = this.validate(this.value);
        if (valid) {
            const date = new Date(this.value);
            this.internalFull = this.value;
            this.internalYear = date.getFullYear();
            this.internalMonth = date.getMonth() + 1;
            this.internalDay = date.getDate();
            this.filled = true;
            this.valid = valid;
        }
    },
    computed: {
        showValidationFeedback() {
            if (this.filled === false) {
                return false;
            }

            return !this.validate(this.value) || !this.validate(this.getCompleteDate());
        },
    },
    watch: {
        value(val) {
            if (val) {
                this.internalFull = val;
            }
          console.log('changed', val);
        },
        internalYear() {
            this.emitDate();
        },
        internalMonth() {
            this.emitDate();
        },
        internalDay() {
            this.emitDate();
        }
    },
    methods: {
        moveToPrevious(field) {
            if (field === 'month' && this.internalMonth === '') {
                this.$refs.year.focus();
            } else if (field === 'day' && this.internalDay === '') {
                this.$refs.month.focus();
            }
        },
        moveToNext(field) {
            if (field === 'year' && this.internalYear.length === 4) {
                this.$refs.month.focus();
            } else if (field === 'month' && this.internalMonth.length === 2) {
                this.$refs.day.focus();
            }
        },
        getCompleteDate() {
            let dayPadding = '';
            let monthPadding = '';

            if (this.internalDay.length === 1) {
                dayPadding = 0;
            }

            if (this.internalMonth.length === 1) {
                monthPadding = 0;
            }

            if (this.internalYear === '' || this.internalMonth === '' || this.internalDay === '') {
                return null;
            }

            return `${this.internalYear}-${monthPadding}${this.internalMonth}-${dayPadding}${this.internalDay}`;
        },
        emitDate() {
            const completeDate = this.getCompleteDate();
            this.valid = this.validate(completeDate);

            if (
                String(this.internalYear).length === 4
                && (String(this.internalMonth).length === 1 || String(this.internalMonth).length === 2)
                && (String(this.internalDay).length === 1 || String(this.internalDay).length === 2)
            ) {
                this.filled = true;
                this.$emit('input', completeDate);
                console.log('complete', completeDate);
            } else {
                console.log('failed change', completeDate);
            }
        },
        validate(completeDate) {
            if (completeDate === null) {
                return false;
            }

            const date = new Date(completeDate);

            try {
                date.toISOString();
                return true;
            } catch (e) {
                return false;
            }
        },
    },
};
</script>

<style scoped>
.date-input {
    display: grid;
    grid-template-columns: 1fr 8px 1fr 8px 1fr;
    align-items: center;
    gap: 8px;

    input {
        width: 100%;
        text-align: center;
    }

    span {
        margin: 0 5px;
    }
}

.validation-area {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    min-height: 40px;
}

::v-deep(input::placeholder) {
    text-transform: lowercase;
}
</style>
